/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'REFERENCE_TO_OVERALL_GOALS_IN_TERMS_OF_SOCIAL_AND_LABOR_OUTCOME',
              'PLEASE_PROVIDE_THE_NAME_OF_DOCUMENT_S_REFERENCING_OVERALL_GOALS',
              'REFERENCE_TO_NATIONAL_LAW',
              'REFERENCE_TO_INTERNATIONAL_LAW_ILO_CONVENTIONS',
              'REFERENCE_TO_OTHER_NATIONAL_OR_INTERNATIONAL_REQUIREMENTS_DECLA',
              'REFERENCE_TO_A_RISK_ASSESSMENT_PROCESS_SPECIFICALLY_A_STRATEGY_',
              'REFERENCE_TO_INTEGRATION_WITH_BUSINESS_OBJECTIVES',
              'REFERENCE_TO_SUPPLIERS_SUBCONTRACTORS_SOCIAL_AND_LABOR_DUE_DILI',
              'REFERENCE_TO_GENDER_EQUALITY_AND_WOMEN_S_EMPOWERMENT',
              'KEY_STAKEHOLDERS_ARE_INVOLVED_IN_STRATEGY_DEVELOPMENT_I_E_CUSTO',
              'PLEASE_DESCRIBE_THE_KEY_STAKEHOLDERS_INVOLVED_',
              'NO_WRITTEN_STRATEGY_GOALS_DOCUMENT_EXISTS_BUT_INFORMAL_STRATEGI',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_a_written_strategy_goals_documents_for_social: valueSchema,
  },
}
